import type { ModeTutorial } from '../tutorial/modeTutorials';
import type { TvSummary } from './summary';
import { tvLayout, tvText, tvTextSection } from './summarySections';

/**
 * A mode's rules as a TV screen (Cole, 2026-10-08: "need a rules button. on
 * tv it'll pop up a rules screen"): the title across the top, the steps as
 * cards in two columns. Shown while the phone's rules card is open.
 */
export function modeRulesTvSummary(
  tutorial: Pick<ModeTutorial, 'title' | 'summary' | 'steps'>,
  colors: { gold: string; textPrimary: string; textSecondary: string; textMuted: string },
): TvSummary {
  const perColumn = Math.ceil(tutorial.steps.length / 2);
  return {
    kicker: 'HOW TO PLAY',
    title: tutorial.title.toUpperCase(),
    rows: [],
    ...tvLayout(
      [
        {
          kind: 'text',
          band: 'top',
          column: 0,
          align: 'center',
          lines: [
            tvText('HOW TO PLAY', colors.textMuted, 'caption', 'bold', 0.15),
            tvText(tutorial.title.toUpperCase(), colors.gold, 'value', 'heavy', 0.03),
            tvText(tutorial.summary, colors.textSecondary, 'body', 'bold'),
          ],
        },
        ...tutorial.steps.map((step, index) =>
          tvTextSection(
            index < perColumn ? 0 : 1,
            [
              tvText(`${index + 1}. ${step.heading.toUpperCase()}`, colors.gold, 'body', 'heavy', 0.06),
              tvText(step.body, colors.textPrimary, 'body', 'regular'),
            ],
            { card: true, align: 'left' },
          ),
        ),
      ],
      [1, 1],
    ),
  };
}
